import 'rxjs/add/operator/debounceTime';
import {Component, ViewChild} from '@angular/core';
import {Content, Keyboard, NavController, NavParams, Searchbar, ViewController} from 'ionic-angular';

import {CONFIG} from '../../../app/config';
import {TFieldType, TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";
import {ENUM, TAction, TProdutoTipo, TUsuarioDono, TUsuarioRole, TContatoTipo} from "../../../app/enum";

import {DomSanitizer} from "@angular/platform-browser";
import {LogadoService} from '../../../providers/logado-service';
import {HotspotService} from "../../../providers/hotspot-service";
import {HotspotRepository} from "../../../repositories/hotspot-repository";
import {ProfilePagePage} from "../profile-page/profile-page";
import {ModalFieldPage} from "../modal-field/modal-field";
import {DragButton} from "../../../components/drag-button/drag-button";
import {WebstorService} from "../../../providers/webstor-service";
import {ProfileRepository} from '../../../repositories/profile-repository';
import {ProfileService} from '../../../providers/profile-service';
import {PrivacyMenuPage} from '../privacy-menu/privacy-menu';
import {ContatoMenuPage} from '../contato-menu/contato-menu';

@Component({
    selector: 'page-usuario-menu',
    templateUrl: 'usuario-menu.html',
    providers: [HotspotService, HotspotRepository, WebstorService, ProfileRepository, ProfileService]
})
export class UsuarioMenuPage {

    ENUM: any = ENUM;
    config: any;

    TAction: any = TAction;
    TProdutoTipo: any = TProdutoTipo;
    TUsuarioDono: any = TUsuarioDono;
    TUsuarioRole: any = TUsuarioRole;

    logado: any;
    rootile: any;

    etapa: number;

    usernew: boolean;
    usuarioLupa: boolean;
    usuarioTela: number;
    userset: any;
    usuario: any;
    changed: any;

    rootspot: any;
    copyspot: any;

    searchTerm: string;
    usuarioRnid: string;
    keyboardDone: number;

    tecladoCode: string;

    akkjson = (window as any).handappMainInstance.appjson;

    @ViewChild(Content) content: Content;
    @ViewChild(DragButton) dragButton: DragButton;
    @ViewChild('searchbar') searchbar: Searchbar;

    constructor(public navCtrl: NavController, public navParams: NavParams,
                private keyboard: Keyboard,
                public util: Util, public sanitizer: DomSanitizer, public viewCtrl: ViewController,
                public profileService: ProfileService, public profileRepository: ProfileRepository,
                public logadoService: LogadoService, public webstorService: WebstorService,
                public hotspotService: HotspotService, public hotspotRepository: HotspotRepository) {

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();

        this.rootile = this.navParams.get('rootile');
        this.etapa = this.navParams.get('etapa');
        this.usernew = this.navParams.get('usernew');
        this.userset = this.navParams.get('userset');
        this.usuario = this.navParams.get('usuario');
        this.rootspot = this.navParams.get('rootspot');
        this.copyspot = this.navParams.get('copyspot');

        this.changed = this.util.deepCopy(this.usuario);
        
        //Flagueia as permissoes do usuario selecionado
        if (this.etapa < 2)
        this.hotspotRepository.usuarioFlag([this.changed], this.rootile.Profile.ProfileID, this.rootile.Profile.ProfileTeam);
        
        //Flagueia usuario code edit
        if (this.etapa == 3)
        this.tecladoCode = this.changed.UsuarioCode;

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Profile User', '/webstor/usuario-menu');

        if (this.etapa == 0) this.usuarioLoad();
        if (this.etapa == 1) this.departaLoad();

    }

    ionViewWillEnter() {

        if (this.etapa == 0 && this.content) this.content.scrollTo(0, 150, 0);

    }

    ionViewDidEnter() {
        
        this.util.statusBarColor(TStatusBar.sbStyleLightContent);
        if (this.etapa == 0 && this.changed.UsuarioOlho) this.dragButton.setChecked(true);

    }

    getTitle() {

        if (this.etapa == 0) return this.changed.Profile.ProfileShow;
        if (this.etapa == 1) return this.changed.Profile.ProfileShow;
        if (this.etapa == 2) return 'Usuario';
        if (this.etapa == 3) return 'Pinumber';
    }

    tecladoLupa() {

        this.usuarioLupa = !this.usuarioLupa;
        if (this.usuarioLupa) setTimeout(() => this.searchbar.setFocus(), 500);
        this.usuarioList(null);

    }


    departaLoad() {
        
        let bool = (this.userset.FlagTeam || this.userset.UsuarioRole < this.changed.UsuarioRole || this.changed.UsuarioRole == TUsuarioRole.urNenhum);

        if (!bool) {
            let king = (this.userset.UsuarioRole == TUsuarioRole.urCEO);
            if ( king) this.util.alertSimply('Configurações para transferir', 'CEO TITULAR', 'OK', false, 'action-sheet-dash');
            if (!king) this.util.alertSimply('Você não pode alterar o cargo', 'DEPARTAMENTO', 'OK', false, 'action-sheet-dash');
            return;
        }

        if (this.akkjson.departas) {
            this.departaInit();
            return;
        }

        let loading = this.util.loadingDots();
        loading.present();

        this.webstorService.departa(TAction.acLoad)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {
                    this.akkjson.departas = data.Departas;
                    this.departaInit();
                },
                erro => this.util.alertResult(erro, () => this.dismiss())
            )

    }

    profilePage() {

        let object = {profileID: this.changed.Profile.ProfileID};
        this.navCtrl.push(ProfilePagePage, object);

    }

    departaInit() {

        if (this.content) this.content.scrollTo(0, 0, 0);
        this.etapa = 1;

    }

    ambientUser() {

        let onSave = (ambient) => {

            this.changed.Ambient = ambient;

            //Save
            this.usuarioSave();

        };


        /** OPEN **/
        let buttons: Array<any> = [];
        buttons.push({text: 'Todos', cssClass: this.util.sheetClass(true, true, 'roxa') + ' shadow-lorean-lime', handler: () => onSave(null)});
        this.copyspot.Hotspots[0].Recintos.forEach(RE => buttons.push({text: RE.Ambient.AmbientNome, handler: () => onSave(RE.Ambient)}));
        buttons.push({text: 'Cancelar', role: 'cancel', cssClass: this.util.sheetClass(true, true, 'food')});
        if (buttons.length > 1) this.util.sheetOpen(buttons, 'AMBIENTE');

    }

    usuarioShow(usuario): boolean {

        if (!usuario) return true;
        
        let team = this.userset.FlagTeam;
        let role = (usuario.UsuarioRole > this.userset.UsuarioRole || this.userset.UsuarioRole == TUsuarioRole.urCEO);
        let none = (usuario.UsuarioRole == TUsuarioRole.urNenhum);
        return (none || team || role);

    }

    usuarioMenu(usuario, usernew: boolean = false) {

        //Manager não pode alterar executivo
        if (!this.usuarioShow(usuario)) return;

        let etapa = (usuario.UsuarioRole ? 0 : 1);
        let object = {etapa: etapa, rootile: this.rootile, usernew: usernew, userset: this.userset, usuario: usuario, rootspot: this.rootspot, copyspot: this.copyspot};
        this.navCtrl.push(UsuarioMenuPage, object);

    }

    usuarioFind() {

        //Finded Profile
        if (!this.util.validaCNPF(this.usuarioRnid)) return;

        this.keyboard.close();
        this.keyboard.onClose(() => {

            let rnid = this.usuarioRnid;
            let ghosterID = this.copyspot.Hotspots[0].Branded.BrandedID;
            this.profileRepository.profileFind(rnid, 'CPF', null, ghosterID).subscribe(
                lino => {

                    this.usuarioRnid = '';

                    //Receita Federal                    
                    this.profileRepository.birthday(PrivacyMenuPage, true, lino, this.userset.FlagTeam).subscribe(data => {

                        //Perfil já esta adicionado, seleciona!
                        let userfnd = this.copyspot.Usuarios.filter(usuario => (usuario.Profile.ProfileID == lino.ProfileID && usuario.HotspotID == this.copyspot.Hotspots[0].HotspotID))[0];

                        //Perfil JÁ esta adicionado, mostra!
                        if (userfnd) this.usuarioMenu(userfnd);

                        //Perfil NAO esta adicionado, adiciona!
                        if (!userfnd) this.usuarioCria(lino);

                    });

                },
                erro => this.usuarioRnid = '');

        });

    }

    usuarioCria(profile) {

        let hotspotID = this.copyspot.Hotspots[0].HotspotID;
        let hotspotNovo = (this.copyspot.Hotspots[0].HotspotID == 0);

        let usuario = this.hotspotRepository.usuarioNull(hotspotID, profile, this.logado.Profile);

        //Hotspot SIM existe
        if (!hotspotNovo) this.usuarioMenu(usuario, true);

        //Hotspot NAO existe
        if (hotspotNovo) this.copyspot.Usuarios.push(usuario);

    }

    usuarioLoad() {

        if (this.usernew) return;

        let hotspotID = this.copyspot.Hotspots[0].HotspotID;
        this.hotspotService.usuario(TAction.acWork, hotspotID, this.usuario.Profile.ProfileID).subscribe(
            root => {

                this.util.populateObj(this.usuario, root.Usuarios[0]);
                this.hotspotRepository.usuarioFlag([this.usuario], this.rootile.Profile.ProfileID, this.rootile.Profile.ProfileTeam);
                this.changed = this.util.deepCopy(this.usuario);

            },
            erro => this.util.toastSimply('Não atualizado')
        );

    }

    usuarioSbar() {

        if (this.keyboardDone) clearTimeout(this.keyboardDone);

        let usuarioText = JSON.stringify(this.copyspot.Usuarios);
        this.usuarioList(null);
        
        let edited = (this.copyspot.Usuarios.length > 0 || usuarioText == JSON.stringify(this.copyspot.Usuarios));
        if (edited) this.keyboardDone = setTimeout(() => this.keyboard.close(), 2000);

    }

    usuarioMore(): boolean {

        let text = ['', 'Checkin', 'Repositor'];
        let usuarios = this.util.deepCopy(this.rootspot.Usuarios);
        usuarios = usuarios.filter(US => !!US.UsuarioLote || text.indexOf(this.hotspotRepository.usuarioNote(US).split(' ')[0]) >= 0);

        return usuarios.length;

    }

    usuarioList(usuarioTela) {

        if (usuarioTela != null) {
            this.usuarioTela = usuarioTela;
            this.util.impact();
        }

        let flag = (this.usuarioLupa ? 3 : (this.usuarioTela == 4 ? 2 : (this.usuarioTela > 0 ? 1 : 0)));
        let text = [];
        if (this.usuarioTela == 1) text = ['Chefe'];
        if (this.usuarioTela == 2) text = ['Caixa'];
        if (this.usuarioTela == 3) text = ['Barman'];
        if (this.usuarioTela == 4) text = ['', 'Checkin', 'Repositor'];

        let usuarios = this.util.deepCopy(this.rootspot.Usuarios);
        if (flag == 0) usuarios = usuarios.filter(US => US.UsuarioRole > TUsuarioRole.urNenhum && US.UsuarioRole < TUsuarioRole.urOperador);
        if (flag == 1) usuarios = usuarios.filter(US => US.UsuarioRole == TUsuarioRole.urOperador && text.indexOf(this.hotspotRepository.usuarioNote(US).split(' ')[0]) >= 0);
        if (flag == 2) usuarios = usuarios.filter(US => US.UsuarioRole > TUsuarioRole.urNenhum && !!US.UsuarioLote || text.indexOf(this.hotspotRepository.usuarioNote(US).split(' ')[0]) >= 0);
        if (flag == 3) usuarios = usuarios.filter(US => US.UsuarioRole > TUsuarioRole.urNenhum && this.util.filterSearch(false, US.Profile, this.searchTerm, ['ProfileID', 'ProfileShow'], ['int', 'str']));

        this.util.clearObj(this.copyspot.Usuarios);
        this.util.populateObj(this.copyspot.Usuarios, usuarios);

    };

    usuarioTwin(operador: 'caxa' | 'sale') {

        let last = this.akkjson.departas.length-1;
        let departa = this.akkjson.departas[last].Departas[0];
        this.usuarioRole(departa, operador);

    }

    usuarioRole(departa, operador: null | 'caxa' | 'sale' = null) {

        let onBack = () => {

            this.copyspot.Usuarios = this.util.deepCopy(this.rootspot.Usuarios);

        };

        let onSave = (usuarioRole) => {

            this.rootspot.Usuarios = this.util.deepCopy(this.copyspot.Usuarios);

            let changeLoad = (this.changed.UsuarioRole != usuarioRole || (usuarioRole == TUsuarioRole.urOperador || this.changed.Departa.DepartaID != departa.DepartaID));

            this.changed.Departa = departa;
            this.changed.UsuarioRole = usuarioRole;
            if (changeLoad) this.hotspotRepository.usuarioNovo(this.changed, operador);

            //Avançado não tem filtro de Ambient
            if (this.changed.UsuarioRole < TUsuarioRole.urOperador) this.changed.Ambient = null;

            //Save
            this.usuarioSave();

        };


        /** OPEN **/
        let preside = (this.akkjson.departas[0].Departas[0].DepartaID == departa.DepartaID);
        let buttons: Array<any> = [];

        if (preside) {
            buttons.push({text: 'CEO',    handler: () => onSave(TUsuarioRole.urCEO)});
            buttons.push({text: 'VP',     handler: () => onSave(TUsuarioRole.urVP)});
        }

        if (!preside) {
            let allowed = (!this.changed.UsuarioFree && this.changed.UsuarioDono > TUsuarioDono.udPDV);
            
            let diretor = (allowed && (this.userset.FlagTeam || this.userset.UsuarioRole <= TUsuarioRole.urVP));
            let gerente = (allowed && (this.userset.FlagTeam || this.userset.UsuarioRole <= TUsuarioRole.urDiretor));
            let operato = (!diretor && !gerente && !!operador);

            if (diretor)  buttons.push({text: 'Diretor',  handler: () => onSave(TUsuarioRole.urDiretor)});
            if (gerente)  buttons.push({text: 'Gestor',   handler: () => onSave(TUsuarioRole.urGestor)});
            if (operato)  buttons.push({text: 'Operador', handler: () => onSave(TUsuarioRole.urOperador)});
        }

        if (buttons.length > 1) buttons.push({text: 'Cancelar', role: 'cancel', cssClass: this.util.sheetClass(true, true, 'food'), handler: () => onBack()});
        this.util.sheetOpen(buttons, departa.DepartaNome.toUpperCase());

    }

    diretorInfo() {

        this.util.alertSimply('Esta permissão só pode ser fornecida por um diretor', 'DIRETORIA', 'OK', false, 'action-sheet-dash');

    }

    usuarioLiga(fieldname, franq) {

        if (fieldname == 'UsuarioHtml') {

            let onOkiy = (that, okiy, index, isLast) => {
                this.changed.UsuarioHtml = okiy[0].groups[0].fields[0].value;
                this.usuarioSave(false, that);
            };

            let fieldHtml = this.config.modalField(TFieldType.ftHtml, null, null, null, this.changed.UsuarioHtml, null, null);
            let groupHtml = this.config.modalGroup(null, [fieldHtml]);
            let slideHtml = this.config.modalSlide('Bibliografia', null, null, null, 'CorRoxa', [groupHtml]);

            this.util.modalopen(ModalFieldPage, 'quad', false, {slides: [slideHtml], onOkiy: onOkiy}).subscribe();

            return;

        }

        if (fieldname && franq) {
            this.changed[fieldname] = (this.changed[fieldname] == 2 ? 1 : 2);
        }

        //Save
        this.util.impact();
        this.usuarioSave();

    }

    usuarioOlho() {

        this.changed.UsuarioOlho = (this.changed.UsuarioOlho ? 0 : 1)
        if ( this.changed.UsuarioOlho) this.changed.UsuarioOlhe = false
        if (!this.changed.UsuarioOlho) this.changed.UsuarioMail = false

        this.usuarioSave()

    }

    usuarioLixo() {

        let alerta = '<b>Deseja excluir </b>' + this.util.nomeFirst(this.changed.Profile.ProfileShow);
        this.util.alertQuestion('ATENÇÃO', alerta, 'Eu CONFIRMO', () => this.usuarioSave(true), false, true);

    }

    usuarioPara() {

        //Contato NEW - Novo
        let contato = {ContatoRede: TContatoTipo.coMail, ContatoFlag: 0, ContatoCode: 0, ContatoUser: this.changed.UsuarioPara, ContatoData: '', ContatoLink: '', ContatoHash: ''};
        
        let object = {etapa: 1, rootile: null, copyile: null, contato: contato};
        this.util.modalopen(ContatoMenuPage, 'alto', false, object)
            .finally(() => '')
            .subscribe(next => {
                this.changed.UsuarioPara = (this.changed.Profile.ContatoMail == this.changed.UsuarioPara ? '' : contato.ContatoUser);
                this.usuarioSave();
            });

    }

    usuarioDono() {

        if (!this.changed.Departa && this.usuario.UsuarioDono == this.changed.UsuarioDono) {
            this.changed.Departa = this.util.deepCopy(this.usuario.Departa);
            this.changed.UsuarioRole = this.usuario.UsuarioRole;
            this.departaInit();
            return;
        }

        let bool = (this.usuario.UsuarioDono == TUsuarioDono.udPDV && this.changed.UsuarioDono > TUsuarioDono.udPDV) ||
                   (this.usuario.UsuarioDono > TUsuarioDono.udPDV && this.changed.UsuarioDono == TUsuarioDono.udPDV);

        //Usuario novo, grava sempre para não voltar se já existir um no cargo qdo escolher e for gravar, não acontecer o rollback da FlagDono
        if (this.usernew || bool || this.changed.UsuarioRole == TUsuarioRole.urNenhum) {
            this.changed.Departa = null;
            this.changed.UsuarioRole = TUsuarioRole.urNenhum;
            //this.usuario.UsuarioDono = this.changed.UsuarioDono;
            this.departaInit();
            return;
        }

        if (this.usuario.UsuarioDono == this.changed.UsuarioDono && 
            this.usuario.UsuarioRole == this.changed.UsuarioRole &&
            this.usuario.Departa == this.changed.Departa) return;

        //Save
        this.usuarioSave();
    }

    usuarioHelp(fieldname, event) {

        let help = '';
        if (fieldname == 'UsuarioBlod') help = 'Sangria e Suprimento';
        if (fieldname == 'UsuarioMenu') help = 'Editar preço de<br>Produto e Serviço (convite)';

        this.util.alertSimply(help, 'PERMISSÕES PARA:');

    }

    tecladoOkey(btn) {
        
        if (btn == 'ok') {            
            this.changed.UsuarioCode = this.tecladoCode;
            this.usuarioSave(false, this);
        }

        else if (btn == 'cancel') {
            
        }

        else if (btn == 'erase') {
            this.tecladoCode = '';
        }

        else if (btn == 'left-thin') {
            let length = this.tecladoCode.length;
            if (length == 1) this.tecladoCode = '';
            if (length > 1)  this.tecladoCode = this.tecladoCode+''.slice(0, length-1);
        }

        else if (btn == 'dot') {
            //
        }

        else if ((this.tecladoCode+'').length < 5) {
            this.tecladoCode = this.tecladoCode + (btn + '');
        }

    }
    
    usuarioCode(press) {

        // AUTOMATIC
        if (!press) {
            this.changed.UsuarioCode = '';
            this.usuarioSave();
        }

        // DIGITAR
        if ( press) {
            let object = {etapa: 3, rootile: this.rootile, usernew: false, userset: this.userset, usuario: this.changed, rootspot: this.rootspot, copyspot: this.copyspot};
            this.util.modalopen(UsuarioMenuPage, 'alto', false, object).subscribe();
        }

    }

    usuarioLote() {

        let onSave = (qtde) => {
            this.changed.UsuarioLote = qtde;
            this.usuarioSave();
        }

        /** OPEN **/
        let buttons: Array<any> = [];
        buttons.push({text: 'Não',   handler: () => onSave(0)});
        buttons.push({text: 'Sim',   handler: () => onSave(1)});

        if (this.userset.FlagZito) {
        buttons.push({text: '5 Vouchers',  handler: () => onSave(5)});
        buttons.push({text: '10 Vouchers', handler: () => onSave(10)});
        buttons.push({text: '15 Vouchers', handler: () => onSave(15)});
        buttons.push({text: '20 Vouchers', handler: () => onSave(20)});
        }

        this.util.sheetOpen(buttons, 'PROMOTER');

    }

    usuarioSave(acLixo: boolean = false, that: any = null) {

        if (!this.copyspot.Hotspots[0].HotspotID) return;

        //Gravar
        let loading = this.util.loadingDots();
        if (this.etapa == 1 || this.etapa == 3) loading.present();

        let action = (acLixo ? TAction.acLixo : TAction.acSave);
        this.hotspotService.usuario(action, this.copyspot.Hotspots[0].HotspotID, this.changed.Profile.ProfileID, this.changed)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {

                    //PINCODE GERADO
                    this.changed.UsuarioCode = this.changed.UsuarioCode || data.Pincode;

                    //EDITADO
                    this.changed.Editado = this.util.deepCopy(this.logado.Profile);
                    this.changed.UsuarioEdit = this.util.dateToStr(this.util.dateHoje(), true);

                    this.util.populateObj(this.usuario, this.changed);

                    //Flagueia as permissoes se alterada do usuario logado
                    if (this.usuario.Profile.ProfileID == this.userset.Profile.ProfileID) {
                        this.hotspotRepository.usuarioFlag([this.userset], this.rootile.Profile.ProfileID, this.rootile.Profile.ProfileTeam);
                    }

                    //Delete Item Source
                    if (action == TAction.acLixo) {
                        let itemIndex = this.copyspot.Usuarios.findIndex(user => user.Profile.ProfileID == this.changed.Profile.ProfileID);
                        this.copyspot.Usuarios.splice(itemIndex, 1);
                        this.rootspot.Usuarios.splice(itemIndex, 1);

                        let toroot = (this.logado.Profile.ProfileID == this.changed.Profile.ProfileID && !this.viewCtrl.isOverlay);
                        if (toroot) this.navCtrl.popToRoot(); else this.dismiss(false, true);
                    }

                    //Change Permission
                    if (action == TAction.acSave && this.usernew) {
                        this.usernew = false;

                        let start = 0;
                        this.copyspot.Usuarios.forEach((user, index) => {
                           if (user.Departa && user.Departa.DepartaID < this.usuario.Departa.DepartaID) start = index + 1;
                        });

                        this.copyspot.Usuarios.splice(start, 0, this.util.deepCopy(this.usuario));
                        this.rootspot.Usuarios.splice(start, 0, this.util.deepCopy(this.usuario));
                    }

                    //Change Department
                    if (this.etapa == 1) {
                        this.usuario.FlagPreside = (this.usuario.UsuarioRole >= TUsuarioRole.urCEO && this.usuario.UsuarioRole <= TUsuarioRole.urVP);
                        this.usuario.FlagDiretor = (this.usuario.UsuarioRole >= TUsuarioRole.urCEO && this.usuario.UsuarioRole <= TUsuarioRole.urDiretor);
                        this.usuario.FlagGerente = (this.usuario.UsuarioRole >= TUsuarioRole.urCEO && this.usuario.UsuarioRole <= TUsuarioRole.urGestor);
                        if (action == TAction.acSave) this.dismiss();
                    }

                    this.util.populateObj(this.rootspot.Usuarios, this.copyspot.Usuarios);
                    //this.rootspot.Usuarios = this.util.deepCopy(this.copyspot.Usuarios);

                    //UsuarioHtml
                    if (that) that.dismiss();

                },
                erro => {
                    let closing = (erro.Action == '#CLOSEWORK#');
                    let onClose = (!closing ? () => {} : () => this.dismiss(true));

                    if (this.dragButton) this.dragButton.setChecked(!!this.usuario.UsuarioOlho);
                    this.changed = this.util.deepCopy(this.usuario);
                    this.util.alertResult(erro, onClose);
                }
            );

    }

    meritumHave(produtoTipo: TProdutoTipo) {

        return this.hotspotRepository.meritumArray(this.copyspot, produtoTipo);

    }

    dismiss(force: boolean = false, deleted?) {

        if (this.etapa == 2) {

            let usuarios = this.rootspot.Usuarios;
            this.util.clearObj(this.copyspot.Usuarios);
            this.util.populateObj(this.copyspot.Usuarios, usuarios);

        }

        if (this.etapa == 1 && !this.usernew && !force && !deleted && this.usuario.Departa) {
            this.etapa = 0;

            if (!this.usernew && !this.changed.Departa) {
                this.util.alertSimply('você não selecionou um departamento.', 'Alteração cancelada', 'Ok', false, 'action-sheet-roxa');
                this.util.populateObj(this.changed, this.usuario);
            }
    
        
            setTimeout(() => this.ionViewDidEnter(), 200);
            return;
        }

        if (this.viewCtrl.isOverlay) {
            this.viewCtrl.dismiss({deleted: deleted}, 'back');
            return;
        }

        this.navCtrl.pop();

    }

}




// WEBPACK FOOTER //
// ./src/pages/sync/usuario-menu/usuario-menu.ts